<script lang="ts">
  import { controlContext } from "@kontextwerk/control-web-frame/shared/logic/authentication"
  import { useContextRootClient } from "@kontextwerk/control-web-frame/shared/logic/context-runtime"
  import type { OrgaViewFrameContext } from "../../../../context"
  import ContextOrderTypes from "./ContextOrderTypes.svelte"

  const { viewFrameContext } = $props<{ viewFrameContext: OrgaViewFrameContext }>()
  const client = useContextRootClient()
  const session = $derived($controlContext?.session ?? null)
  const organizationId = $derived(
    viewFrameContext.organization?.id ?? viewFrameContext.organizationId ?? null,
  )
</script>

<!-- One bound catalog per confirmed context and organization; a switch remounts it. -->
{#if session && organizationId}
  {#key `${session.session_id}:${session.context_revision}:${organizationId}`}
    <ContextOrderTypes {client} {session} {organizationId} />
  {/key}
{:else}
  <p role="status">Auftragstypen werden geladen.</p>
{/if}
